import {NgModule} from '@angular/core';
import {TitleComponent} from './title/title.component';
import {MatButtonModule} from '@angular/material/button';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {CommonModule} from '@angular/common';
import {ShellModule} from '../../modules/shell/shell.module';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { HeaderComponentComponent } from './header-component/header-component.component';
import { GalleryModalComponent } from './gallery-modal/gallery-modal.component';
import {IvyGalleryModule} from 'angular-gallery';
import { FormsModule } from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { ModelComentarioComponent } from './model-comentario/model-comentario.component';
import { PaginadorGeneralComponent } from './paginador-general/paginador-general.component';
import { SpinnerOverlayComponent } from './spinner-overlay/spinner-overlay.component';
import { RangeComponent } from './range/range.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { ModalAvisosComponent } from 'src/app/modules/administracion/components/modal-avisos/modal-avisos.component';
//import { ModalAvisosComponent } from 'src/app/modules/administracion/components/modal-avisos/modal-avisos.component';

@NgModule({
  declarations:[TitleComponent, HeaderComponentComponent, GalleryModalComponent, ModelComentarioComponent, PaginadorGeneralComponent, SpinnerOverlayComponent, RangeComponent],
  imports:[NgxSliderModule,MatProgressSpinnerModule,IvyGalleryModule,CommonModule, ShellModule, MatToolbarModule, MatProgressBarModule, MatButtonModule, MatGridListModule,
    MatDialogModule, MatIconModule, MatChipsModule, MatTableModule,FormsModule,BrowserModule,ReactiveFormsModule],
  providers:[],
  exports:[SpinnerOverlayComponent,RangeComponent,PaginadorGeneralComponent,ModelComentarioComponent,HeaderComponentComponent, 
  GalleryModalComponent],
  entryComponents:[]
})
export class SharedModule {
}
